export function generateErrorHTMLWindow() {
  return `
  <div class="container">
    <div class="error_modal">
      <svg class="mpdal-close-svg error_modal-svg-close" width="24" height="24">
        <use href="/img/svg/sprite.svg#close"></use>
      </svg>
      <h2 class="error_modal-title">We’re working on it</h2>
      <p class="error_modal-subtitle">
        While you travel, we’re improving your experience.
      </p>
      <button class="button modal-close">Continue</button>
    </div>
  </div>
  `;
}
